import { brandLogomarkAbsoluteUrl } from './brand-assets';

const SOCIAL_MARK = 'data-ywc-social';

/** Default share image (absolute URL). */
export function getDefaultShareImageUrl(): string {
  return brandLogomarkAbsoluteUrl();
}

export type OgType = 'website' | 'article';

function removeManagedSocialMeta(): void {
  document.querySelectorAll(`meta[${SOCIAL_MARK}]`).forEach((el) => el.remove());
}

function appendMeta(attrs: Record<string, string>, content: string): void {
  const meta = document.createElement('meta');
  meta.setAttribute(SOCIAL_MARK, '');
  for (const [k, v] of Object.entries(attrs)) {
    meta.setAttribute(k, v);
  }
  meta.setAttribute('content', content);
  document.head.appendChild(meta);
}

/**
 * Open Graph + Twitter Card tags for link previews (Facebook, LinkedIn, Slack, iMessage, etc.).
 */
export function setSocialPreview(params: {
  title: string;
  description: string;
  canonicalUrl: string;
  ogType: OgType;
}): void {
  removeManagedSocialMeta();
  const image = getDefaultShareImageUrl();

  appendMeta({ property: 'og:title' }, params.title);
  appendMeta({ property: 'og:description' }, params.description);
  appendMeta({ property: 'og:url' }, params.canonicalUrl);
  appendMeta({ property: 'og:type' }, params.ogType);
  appendMeta({ property: 'og:site_name' }, 'Yes We Can LLC');
  appendMeta({ property: 'og:image' }, image);
  appendMeta({ property: 'og:image:alt' }, 'Yes We Can LLC');
  appendMeta({ property: 'og:locale' }, 'en_US');

  appendMeta({ name: 'twitter:card' }, 'summary_large_image');
  appendMeta({ name: 'twitter:title' }, params.title);
  appendMeta({ name: 'twitter:description' }, params.description);
  appendMeta({ name: 'twitter:image' }, image);
}

export function clearSocialPreview(): void {
  removeManagedSocialMeta();
}
